import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import CheckIcon from './CheckIcon';
import { formatDate, formatTime } from '../../../../../utils';
import * as EventActions from '../../../../../core/events/action';
import { VENUE_FEATURES } from '../../../../../constants/venue';

export default function AboutYourEvent({
  registeredAttendees,
  vendors,
  foodTrucks,
  // event,
  venue,
  freeFeatures,
  seeDigitalMarketing,
}) {
  const dispatch = useDispatch();
  const {
    events: { event, urlData },
    users: { user },
  } = useSelector((store) => store);

  if (!event?.id) return false;
  // eslint-disable-next-line react-hooks/rules-of-hooks

  const parametersEvent = event?.parameters_event;
  const { state, city } = event;

  const getVeneFeatureFree = () => {
    const iconList = [];
    venue?.link_venue_features.forEach((fe) => {
      const wanted = VENUE_FEATURES.find((i) => i.id === fe.fk_feature);
      if (wanted) iconList.push(wanted);
    });
    return iconList;
  };

  return (
    <SimpleCard>
      <div>
        <Typography variant="h6" marginTop={0}>
          About your event:
        </Typography>
      </div>

      <Grid container marginY={3} columnSpacing={{ xs: 0, md: 10 }}>
        <Grid item xs={12} md={6}>
          <div>
            <Typography>{event?.description}</Typography>
            <Typography>{`${event?.street_address}, ${city.name}, ${state.state_code}`}</Typography>
            <Typography>
              <span>Digital marketing:</span>
              <CheckIcon checked={parametersEvent?.digital_marketing} />
              {parametersEvent?.digital_marketing && seeDigitalMarketing && urlData && (
                <a href={urlData}> Download here!</a>
              )}
            </Typography>
            <Typography>
              Commercial insurance:
              <CheckIcon checked={parametersEvent?.commercial_insurance} />
            </Typography>

            {parametersEvent?.repeat_every && (
              <Typography>Repeat every {parametersEvent?.repeat_every}</Typography>
            )}
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Typography>
              Event date: {formatDate(parametersEvent?.event_date)} from{' '}
              {formatTime(parametersEvent?.hour_start_event)} to{' '}
              {formatTime(parametersEvent?.hour_end_event)}
            </Typography>
            <Typography>
              Event setup: {formatTime(parametersEvent?.hour_vendor_setup_start)}
            </Typography>
            <Typography>
              Event take down: From {formatTime(parametersEvent?.hour_vendor_take_down_start)} to{' '}
              {formatTime(parametersEvent?.hour_vendor_take_down_end)}
            </Typography>
            <Typography>
              Cancelation deadline: {formatDate(parametersEvent?.cancellation_deadline)}
            </Typography>
            <Typography>
              Application deadline: {formatDate(parametersEvent?.application_deadline)}
            </Typography>
            {parametersEvent?.refund_deadline && (
              <Typography>
                Refund deadline: {formatDate(parametersEvent?.refund_deadline)}{' '}
                {parametersEvent?.hour_refund_deadline}
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>

      <Grid container justifyContent="space-between" marginTop={2}>
        <Grid item sm={6}>
          <Typography variant="h7" marginTop={0}>
            This venue includes:
          </Typography>
        </Grid>
        <Grid item sm={6}>
          <Grid container justifyContent="flex-start">
            {freeFeatures.map((item) => (
              <Grid item key={item.id}>
                <img style={{ marginRight: 10, width: 30 }} src={item.Icon} alt={item.name} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </SimpleCard>
  );
}

AboutYourEvent.propTypes = {
  registeredAttendees: PropTypes.number,
  vendors: PropTypes.number,
  foodTrucks: PropTypes.number,
  // event: PropTypes.instanceOf(Object).isRequired,
  venue: PropTypes.instanceOf(Object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  freeFeatures: PropTypes.any.isRequired,
  seeDigitalMarketing: PropTypes.bool,
};

AboutYourEvent.defaultProps = {
  registeredAttendees: 1,
  vendors: 1,
  foodTrucks: 1,
  seeDigitalMarketing: false,
};
